import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Link } from "react-router-dom";
import client from "./contentfulClient";

const SwiperComponent = () => {
  const [projects, setProjects] = useState([]);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    client
      .getEntries({ content_type: "postProduction" })
      .then((res) => {
        setProjects(res.items.slice(0, 8));
      })
      .catch(console.error);
  }, []);

  useEffect(() => {
    if (
      swiperRef.current &&
      swiperRef.current.params &&
      prevRef.current &&
      nextRef.current
    ) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;
      swiperRef.current.navigation.destroy();
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, [projects]);

  return (
    <section className="section-three-cards">
      <div className="container">
        <div className="swiper-outer-wrapper">
          <Swiper
            onSwiper={(swiper) => (swiperRef.current = swiper)}
            modules={[Navigation]}
            slidesPerView={1.1}
            spaceBetween={16}
            navigation={false}
            breakpoints={{
              768: { slidesPerView: 2, spaceBetween: 20 },
              1024: { slidesPerView: 3, spaceBetween: 24 },
              1440: { slidesPerView: 3, spaceBetween: 24 },
            }}
          >
            {projects.map((item) => {
              const { title, thumbnail } = item.fields;
              const imageUrl = thumbnail?.fields?.file?.url;

              return (
                <SwiperSlide key={item.sys.id}>
                  <Link to={`/post-production/${item.sys.id}`}>
                    <div className="three-card">
                      <img
                        src={imageUrl ? `https:${imageUrl}` : "/assets/img/placeholder.png"}
                        alt={title}
                      />
                      <p>{title}</p>
                    </div>
                  </Link>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>

        <div className="button-group">
          <div ref={prevRef} className="custom-nav-button prev-button">
            <svg viewBox="0 0 24 24">
              <path d="M15 6l-6 6 6 6" stroke="currentColor" strokeWidth="2" fill="none" />
            </svg>
          </div>
          <div ref={nextRef} className="custom-nav-button next-button">
            <svg viewBox="0 0 24 24">
              <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" fill="none" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SwiperComponent;
